import { AppDefinition } from '../../types/apps';

export const CHART_EVENTS = {
  OPEN: 'CHART_OPEN',
  CHANGE: 'CHART_CHANGE',
  EXPORT: 'CHART_EXPORT',
  AI_UPDATE: 'CHART_AI_UPDATE',
} as const;

export const ChartAppDefinition: AppDefinition = {
  appId: 'chart',
  name: 'Chart',
  version: '0.1.0',
  description:
    'Data visualization app for scatterplots, 2x2 priority matrices, bar charts, and line charts — powered by recharts, with an editable data grid and AI-authored specs.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'ChartLineUp',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
    metadata: { source: 'app', appId: 'chart', isAppIcon: true },
  },
  entityIcons: {
    Chart: {
      type: 'phosphor',
      phosphorIcon: 'ChartLineUp',
      phosphorWeight: 'duotone',
      color: '#8b5cf6',
    },
  },
  events: CHART_EVENTS,
  entityTypes: ['Chart'],
  // The Y.Doc is the source of truth; only the small skeleton mirror is
  // ever indexed. Never include the full `data` rows.
  searchableSkeletonFields: {
    Chart: ['description', 'tags'],
  },
  component: 'ChartApp',
  requiresProps: false,
  requiresEntity: true,
  agenticToolIds: [
    'chart_create',
    'chart_update',
    'chart_read',
  ],
  actions: {},
};

export default ChartAppDefinition;
